import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M43.7 15.2c-.7 0-1.2.6-1.2 1.2v.7H34L28 20l-1.1 4.7-4.4-2.1-4.4 2.1L17 20l-6-2.9H2.5v-.7c0-.7-.6-1.2-1.2-1.2S0 15.7 0 16.4v24c0 .7.6 1.2 1.2 1.2s1.2-.6 1.2-1.2v-.7h40v.7c0 .7.6 1.2 1.2 1.2s1.2-.6 1.2-1.2v-24c.2-.7-.4-1.2-1.1-1.2zM2.5 37.3V19.6h7.9l4.5 2.1 1.5 6.6 6.1-3 6.1 3 1.5-6.6 4.5-2.1h7.9v17.7h-40z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M23.8 19l7.4-5.2c.8-.6.9-1.8.2-2.5s-1.9-.6-2.5.2L23.8 19z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M21.2 19L16 11.6c-.6-.8-1.8-.9-2.5-.2s-.6 1.9.2 2.5l7.5 5.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M22.5 15.4l1.6-8.9c.2-1-.6-1.9-1.6-1.9s-1.8.9-1.6 1.9l1.6 8.9z"
		})
	]
});
export default SvgIcon;
